import { useMemo } from 'react';
import { buildContainerMotionConfig, type ContainerMotionConfig } from './CcontainerMotion';
import type { CcontainerProps } from './Ccontainer.types';

const DEFAULT_CLICK_ANIMATION = false;
const DEFAULT_ANIMATION_DURATION_MS = 200;

interface UseContainerMotionModelInput {
  props: CcontainerProps;
  isPressed: boolean;
}

export function useContainerMotionModel(input: UseContainerMotionModelInput): ContainerMotionConfig {
  const { props, isPressed } = input;
  const {
    clickAnimation = DEFAULT_CLICK_ANIMATION,
    onClick,
    animationDuration = DEFAULT_ANIMATION_DURATION_MS,
    preserveStyle,
    rootMotion,
  } = props;

  return useMemo(() => buildContainerMotionConfig({
    clickAnimation,
    onClick,
    animationDuration,
    preserveStyle,
    rootMotion,
    isPressed,
  }), [animationDuration, clickAnimation, isPressed, onClick, preserveStyle, rootMotion]);
}
